/**
 * Auth0 configuration for Public Records dashboard
 */
export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_IDENTIFIER,
    // offline_access required for refresh tokens (silent renewal without iframe)
    scope: 'openid profile email offline_access',
  },
  useRefreshTokens: true,
  cacheLocation: 'localstorage' as const,
  // Prefer refresh tokens; iframe fallback only if refresh token flow fails
  useRefreshTokensFallback: true,
}

export function currentReturnTo(): string {
  return `${window.location.pathname}${window.location.search}${window.location.hash}`
}

export const AUTH0_NAMESPACE = 'https://compliance.theary.com'

export const AUTH0_CLAIMS = {
  ROLE: `${AUTH0_NAMESPACE}/roles`,
  TENANT_ID: `${AUTH0_NAMESPACE}/tenant_id`,
  TENANT_IDS: `${AUTH0_NAMESPACE}/tenant_ids`,
  CLIENT_ID: `${AUTH0_NAMESPACE}/client_id`,
  CLIENT_NAME: `${AUTH0_NAMESPACE}/client_name`,
  CLIENT_IDS: `${AUTH0_NAMESPACE}/client_ids`,
  PERMISSIONS: `${AUTH0_NAMESPACE}/permissions`,
} as const

export const TENANT_ID_HEADER = 'x-tenant-id'
export const SELECTED_TENANT_STORAGE_KEY = 'snh_selected_tenant_id'

// Backward-compatible aliases while the rest of the dashboard migrates off client-* naming.
export const CLIENT_ID_HEADER = TENANT_ID_HEADER
export const SELECTED_CLIENT_STORAGE_KEY = SELECTED_TENANT_STORAGE_KEY

export type InternalRole =
  | 'Public-Records-Admin'
  | 'Public-Records-Expert'
  | 'Public-Records-Executive'

export type ExternalRole = 'Client-Admin' | 'Client-User'

export type UserRole = InternalRole | ExternalRole

export type Permission =
  | 'view:dashboards'
  | 'view:reportability'
  | 'view:identity-match'
  | 'view:routing'
  | 'view:all-data'
  | 'view:pii'
  | 'export:full-data'
  | 'export:filtered-data'
  | 'manage:settings'
  | 'manage:team'

export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  'Public-Records-Admin': [
    'view:dashboards',
    'view:reportability',
    'view:identity-match',
    'view:routing',
    'view:all-data',
    'view:pii',
    'export:full-data',
    'export:filtered-data',
    'manage:settings',
  ],
  'Public-Records-Expert': [
    'view:dashboards',
    'view:reportability',
    'view:identity-match',
    'view:routing',
    'view:all-data',
    'export:filtered-data',
  ],
  'Public-Records-Executive': [
    'view:dashboards',
    'export:filtered-data',
  ],
  'Client-Admin': [
    'view:dashboards',
    'view:reportability',
    'view:identity-match',
    'view:routing',
    'export:filtered-data',
    'manage:team',
  ],
  'Client-User': [
    'view:dashboards',
    'view:reportability',
    'view:identity-match',
    'view:routing',
  ],
}
